import type { Editor } from 'tinymce'
import type { TinyMCEButtons, TinyMCEInserterOptions, ValidElements } from './types'

export const INSERTER = 'inserter'

export const getToolbar = (buttons: TinyMCEButtons) => {
  const blocks = buttons.blocks ? 'blocks' : ''
  const strikethrough = '' // permanently disabled for now
  const table = buttons.table ? 'table' : ''
  const code = buttons.code ? 'code' : ''
  const fullscreen = buttons.fullscreen ? 'fullscreen' : ''
  const alignment = buttons.alignment ? 'alignleft aligncenter alignright alignjustify' : ''
  const image = buttons.image ? 'image' : ''
  const customImage = buttons.customImage ? 'customImage' : ''

  return `${blocks} bold italic underline ${strikethrough} bullist numlist ${image} ${customImage} ${alignment} link ${table} ${INSERTER} ${code} ${fullscreen}`
}

export const setupInserter = (
  editor: Editor,
  inserterOptions: TinyMCEInserterOptions | undefined,
) => {
  if (inserterOptions && inserterOptions.length) {
    editor.ui.registry.addMenuButton(INSERTER, {
      text: 'Insert',
      icon: 'addtag',
      fetch: (success) => {
        const menu = inserterOptions.map((option) => ({
          type: 'menuitem' as const,
          text: option.label,
          onAction: () => editor.insertContent(option.text),
        }))

        success(menu)
      },
    })
  }
}

export const mapValidElementsToString = (validElements: ValidElements) => {
  const elements = Object.keys(validElements).map((key) => {
    const attributes = validElements[key]

    return attributes === true ? key : `${key}[${attributes.join('|')}]`
  })

  return elements.join(',')
}

export const mapValidStyles = (validStyles: string[]): Record<string, string> => ({
  '*': validStyles.map((item) => item.replace('()', '')).join(','),
})
